import React, { useState } from "react";
import { ScrollAnimation } from "../ScrollAnimation";
import { X } from "lucide-react";

const professionals = [
  {
    id: "maria-ines",
    name: "Dra. Maria Inês Mesquita",
    role: "Psiquiatra e Psicoterapeuta",
    crm: "CRM-SC 19697 RQE 11246",
    image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/maria%20ines-ECGVl3z9V5sC6LmuIeRmOTkQCFlrDI.jpeg",
    shortBio: "Maria Inês Kalil Juliano de Mesquita acredita que a transformação em saúde mental acontece a partir de um vínculo terapêutico seguro, aliado a uma abordagem clinicamente embasada e comprometida com a ciência.",
    fullBio: `Maria Inês Kalil Juliano de Mesquita acredita que a transformação em saúde mental acontece a partir de um vínculo terapêutico seguro, aliado a uma abordagem clinicamente embasada e comprometida com a ciência.

Com foco no atendimento de adolescentes e adultos, dedica sua prática ao cuidado em saúde mental com foco em profundidade clínica, unindo rigor científico, sensibilidade e uma presença que permite ao paciente sentir-se genuinamente compreendido para além dos sintomas.

Sua atuação abrange o tratamento de quadros como ansiedade, depressão, transtorno bipolar, transtornos relacionados ao trauma, TOC, fobias e TDAH, sempre com explicações claras e precisão diagnóstica. Além das patologias psiquiátricas, oferece suporte especializado para conflitos internos e interpessoais, acolhendo quem busca ajuda, independentemente de um diagnóstico.

Psiquiatra e psicoterapeuta com mais de três décadas de experiência, integra a neurociência a um olhar especializado para o impacto do trauma ao longo da vida. Sua prática combina a Terapia Cognitivo-Comportamental, a Terapia Sistêmica e abordagens de reprocessamento de memórias (EMDR e Brainspotting). Atua também na integração da Psicoterapia Assistida por Cetamina (PAC) a processos terapêuticos estruturados.

Além da atuação clínica, dedica-se à transmissão de conhecimento como docente e palestrante. Ministra cursos em técnicas psicoterápicas, trauma psicológico e abordagens integradas, sendo professora colaboradora do Instituto de Terapia Cognitivo-Comportamental de Porto Alegre (InTCC–POA) nos cursos de especialização em trauma e EMDR. É também Supervisora Certificada EMDR pela Associação Ibero-Americana de Psicotrauma (AIBAPT).

Formação e Filiações:

• Graduada em Medicina pela Fundação Universidade do Rio Grande (FURG)
• Psiquiatra pela Universidade Federal do Rio Grande do Sul (UFRGS)
• Especialista em Técnicas Psicoterápicas Especiais pela Universidade Federal do Rio Grande do Sul (UFRGS)
• Especialista em Psicoterapia de Família e de Casal pelo Centro de Estudos da Família e do Indivíduo (CEFI – Porto Alegre)
• Formação em Terapia Cognitivo-Comportamental de Crianças, Adolescentes e Adultos pelo Instituto de Terapia Cognitivo-Comportamental de Porto Alegre (InTCC–POA)
• Membro da Associação Brasileira de Psiquiatria (ABP)
• Membro da Associação Brasileira de EMDR
• Membro da Associação Ibero-Americana de Psicotrauma (AIBAPT) e integrante do Comitê de Certificação e Cursos Avançados

Mantém formação contínua e atualização em congressos nacionais e internacionais, com foco em práticas baseadas em evidências e na compreensão da singularidade de cada paciente.`,
  },
  {
    id: "carlos",
    name: "Dr. Carlos Heitor Mesquita",
    role: "Psiquiatra e Psicoterapeuta",
    crm: "CRM-SC 19698 RQE 11793",
    image: "https://customer-assets.emergentagent.com/job_ambiente-deploy/artifacts/amqkiv48_WhatsApp%20Image%202026-04-25%20at%2015.23.30.jpeg",
    shortBio: "Carlos Heitor Alves de Mesquita acredita que o tratamento em saúde mental vai além da remissão de sintomas, envolvendo a compreensão de como a história de vida, o funcionamento cerebral e os padrões emocionais se organizam em cada indivíduo.",
    fullBio: `Carlos Heitor Alves de Mesquita acredita que o tratamento em saúde mental vai além da remissão de sintomas, envolvendo a compreensão de como a história de vida, o funcionamento cerebral e os padrões emocionais se organizam em cada indivíduo. Sua prática integra psiquiatria e psicoterapia, com foco em intervenções que promovam mudanças consistentes e sustentáveis ao longo do tempo.

Atua com jovens, adultos e idosos no tratamento de quadros como ansiedade, depressão, transtorno bipolar, transtorno de déficit de atenção e hiperatividade (TDAH), transtornos relacionados ao uso de substâncias e trauma psíquico, articulando a precisão do diagnóstico médico com uma escuta clínica atenta e individualizada. Seu trabalho considera tanto a neurobiologia dos sintomas quanto o contexto de vida e a organização emocional do paciente.

Psiquiatra e psicoterapeuta, possui formação que permite transitar entre diferentes níveis de profundidade clínica. Tem base em Psicoterapia de Orientação Analítica pela Fundação Universitária Mário Martins (FUMM), integrada à Terapia Cognitivo-Comportamental (TCC), com formação pelo Instituto Catarinense de Terapia Cognitiva (ICTC) e pelo Instituto de Terapia Cognitivo-Comportamental de Porto Alegre (InTCC–POA).

É especialista em trauma psíquico, terapeuta EMDR certificado pela Associação Ibero-Americana de Psicotrauma (AIBAPT) e terapeuta de Brainspotting, com formação pela TraumaClinic (Brasil). Possui ainda formação em Inteligência Sistêmica e Abordagem Fenomenológica pelo IDESV. Atua também com Psicoterapia Assistida por Cetamina, integrada a planos terapêuticos estruturados para casos de maior complexidade clínica.

Além da prática clínica, atua na formação de profissionais como docente e palestrante, ministrando cursos sobre psicoterapia, trauma psicológico e intervenções assistidas, incluindo o uso de psicodélicos em saúde mental, com ênfase em práticas baseadas em evidências.

Seu trabalho se orienta pela construção de um cuidado individualizado, atento à complexidade de cada caso e voltado a mudanças que possam se sustentar ao longo do tempo.

Formação e Filiações:

• Médico pela Fundação Universidade Federal do Rio Grande (FURG)
• Psiquiatra pela Fundação Universitária Mário Martins (FUMM) e Associação Brasileira de Psiquiatria (ABP)
• Especialização em Terapia Cognitiva (Adultos) pelo Instituto Catarinense de Terapia Cognitiva (ICTC)
• Formação em Terapia Cognitivo-Comportamental da Infância e Adolescência pelo Instituto de Terapia Cognitivo-Comportamental de Porto Alegre (InTCC–POA)
• Formação em Inteligência Sistêmica e Abordagem Fenomenológica pelo IDESV
• Terapeuta EMDR (TraumaClinic – Brasil)
• Terapeuta Brainspotting (TraumaClinic – Brasil)
• Membro da Associação Brasileira de Psiquiatria (ABP)
• Membro da Associação Ibero-Americana de Psicotrauma (AIBAPT)`,
  },
  {
    id: "celina",
    name: "Celina Darde",
    role: "Psicóloga",
    crm: "CRP 07/08960",
    image: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/celina-4zyuKhYIKCctv0cw5eRk40o0J5ejpF.jpeg",
    shortBio: "Acredita que trabalhar com saúde mental é um grande privilégio e vê a psicoterapia como um espaço de troca, em que paciente e terapeuta caminham juntos na construção de novos sentidos, mais consciência e qualidade de vida.",
    fullBio: `Acredita que trabalhar com saúde mental é um privilégio, pois cada encontro humano também a transforma. Compreende a psicoterapia como um espaço de construção conjunta, no qual paciente e terapeuta caminham lado a lado no desenvolvimento de maior consciência emocional, integração, equilíbrio e qualidade de vida.

Sua prática integra ciência e sensibilidade, combinando abordagens terapêuticas baseadas em evidências com uma escuta atenta, empática e respeitosa à história de cada pessoa.

Atua com psicoterapia para adultos, auxiliando no cuidado com a saúde mental e no fortalecimento de recursos emocionais.

Abordagens terapêuticas:

• Terapia Cognitivo-Comportamental (TCC)
• EMDR (reprocessamento de memórias traumáticas)
• Psicologia Positiva
• AIM e INSIDELIC
• Psicoterapia Assistida por Cetamina (KAP), indicada em contextos específicos e integrada ao processo terapêutico

Como funciona a psicoterapia:

A psicoterapia é um processo que auxilia na compreensão de padrões emocionais, desenvolvendo mais consciência e autonomia.`,
  },
];

export default function Team() {
  const [selectedProfessional, setSelectedProfessional] = useState(null);

  return (
    <>
      <section id="equipe" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-[#f8f6f1]">
        <div className="max-w-6xl mx-auto">
          <ScrollAnimation animation="fade-up">
            <span className="font-sans text-sm font-semibold text-[#C2A44A] tracking-wider uppercase mb-3 block text-center">Nossa Equipe</span>
          </ScrollAnimation>
          <ScrollAnimation animation="fade-up" delay={100}>
            <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#204613] mb-8 text-center text-balance max-w-4xl mx-auto leading-tight">
              Profissionais dedicados ao seu cuidado
            </h2>
          </ScrollAnimation>
          <ScrollAnimation animation="fade-up" delay={150}>
            <p className="font-serif text-base sm:text-lg text-[#3d3d3d] mb-12 text-center max-w-2xl mx-auto">
              Uma equipe multidisciplinar com experiência, sensibilidade e compromisso com a sua saúde mental.
            </p>
          </ScrollAnimation>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {professionals.map((professional, idx) => (
              <ScrollAnimation key={professional.id} animation="fade-up" delay={200 + idx * 100}>
                <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group h-full flex flex-col">
                  <div className="relative aspect-square sm:aspect-auto sm:h-80 overflow-hidden">
                    <img
                      src={professional.image}
                      alt={professional.name}
                      className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${professional.imagePosition || "object-top"}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#204613]/60 via-transparent to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                      <h3 className="font-sans text-xl sm:text-2xl font-bold text-white mb-1">{professional.name}</h3>
                      <p className="font-serif text-white/90 text-sm">{professional.role}</p>
                      <p className="font-serif text-white/75 text-xs">{professional.crm}</p>
                    </div>
                  </div>
                  <div className="p-5 sm:p-6 flex flex-col flex-grow">
                    <p className="font-serif text-sm sm:text-base text-[#4a4a4a] leading-relaxed mb-4 flex-grow">
                      {professional.shortBio}
                    </p>
                    <button
                      onClick={() => setSelectedProfessional(professional)}
                      className="inline-flex items-center gap-2 font-sans text-sm font-semibold text-[#204613] hover:text-[#C2A44A] transition-colors duration-300 self-start"
                    >
                      Leia mais
                      <span className="text-lg">→</span>
                    </button>
                  </div>
                </div>
              </ScrollAnimation>
            ))}
          </div>
        </div>
      </section>

      {selectedProfessional && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] flex items-center justify-center p-4"
          onClick={() => setSelectedProfessional(null)}
        >
          <div
            className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <div className="flex items-center justify-center bg-[#f8f6f1] p-6 sm:p-8">
                <img
                  src={selectedProfessional.image}
                  alt={selectedProfessional.name}
                  className="w-40 h-40 sm:w-48 sm:h-48 rounded-full object-cover object-top shadow-xl border-4 border-white"
                />
              </div>
              <button
                onClick={() => setSelectedProfessional(null)}
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center transition-colors shadow-lg z-10"
              >
                <X className="w-5 h-5 text-[#204613]" />
              </button>
            </div>
            <div className="text-center px-6 pt-4 pb-2 border-b border-[#ACC996]/30">
              <h3 className="font-sans text-2xl sm:text-3xl font-bold text-[#204613] mb-1">{selectedProfessional.name}</h3>
              <p className="font-serif text-[#698658]">{selectedProfessional.role}</p>
              <p className="font-serif text-[#4a4a4a] text-sm">{selectedProfessional.crm}</p>
            </div>
            <div className="p-6 sm:p-8">
              <div className="prose prose-lg max-w-none">
                {selectedProfessional.fullBio.split("\n\n").map((paragraph, idx) => (
                  <p key={idx} className="font-serif text-base sm:text-lg text-[#3d3d3d] leading-relaxed mb-4">
                    {paragraph}
                  </p>
                ))}
              </div>
              <div className="mt-8 pt-6 border-t border-[#ACC996]/30">
                <a
                  href="https://wa.me/5548992100333"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 w-full px-6 py-4 bg-[#204613] text-white rounded-xl font-sans font-semibold text-base hover:bg-[#2d5a1a] transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  Agendar Consulta
                  <span className="text-lg">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
